export default __webpack_public_path__ + "static/media/Benjamin-Proulx-Mathers-7b.31ed7eb3.jpg";